// Lightweight Firebase initialization wired to project 'lunar-electric'.
// Paste your actual Firebase web app config below from Firebase Console > Project Settings > Web app.
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";

// IMPORTANT: Replace placeholders with real config values.
const firebaseConfig = {
  apiKey: "AIzaSyBCla7CuX2mDnKwm8VTdHBtAhLfytO7bm4",
  authDomain: "lunar-electric.firebaseapp.com",
  projectId: "lunar-electric",
  // Note: Storage bucket isn't required for this client-side approach, keeping default for completeness.
  storageBucket: "lunar-electric.firebasestorage.app",
  messagingSenderId: "177936474713",
  appId: "1:177936474713:web:bf4fe2a066ec735c380748",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const functions = firebase.functions();
export const storage = firebase.storage();
export default firebase;


